import { Route } from '@angular/router';
import { AuthGuard } from './core/guard/auth.guard';

export const appRoutes: Route[] = [
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
        data: { title: 'Login' }
    },
    {
    path: 'pri',
    children: [
        {
            path: '',
            redirectTo: 'report',
            pathMatch: 'full'
        },
        {
            path: 'sottoscrizione',
            loadComponent: () => import('./pages/sottoscrizione/sottoscrizione.component').then(m => m.SottoscrizioneComponent),
            canActivate: [AuthGuard],
            data: { title: 'Inserimento Sottoscrizione', expectedRoles: ['ESATTORE'] }
        },
        {
            path: 'contanti',
            loadComponent: () => import('./pages/contanti/contanti.component').then(m => m.ContantiComponent),
            canActivate: [AuthGuard],
            data: { title: 'Contanti', expectedRoles: ['ESATTORE'] }
        },
        {
            path: 'versamenti',
            loadComponent: () => import('./pages/versamenti/versamenti.component').then(m => m.VersamentiComponent),
            canActivate: [AuthGuard],
            data: { title: 'Versamenti', expectedRoles: ['CASSIERE'] }
        },
        {
            path: 'report',
            loadComponent: () => import('./pages/report/report.component').then(m => m.ReportComponent),
            canActivate: [AuthGuard],
            data: { title: 'Report' }
        },
        {
            path: 'storico',
            loadComponent: () => import('./pages/storico/storico.component').then(m => m.StoricoComponent),
            canActivate: [AuthGuard],
            data: { title: 'Storico' }
        }
      ]
    },
      {
    path: 'not-found',
    loadComponent: () => import('./pages/not-found/not-found.component').then(m => m.NotFoundComponent),
    data: { title: 'Not Found' }
  },
    {
        path: '**',
        redirectTo: 'not-found'
    },
];
